module.exports = __webpack_public_path__ + "4db146075d93a4d91b89f5d5be7e1572.png";